require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-is-data-killing-creativity.json") })
        }
      }, "path---authors-is-data-killing-creativity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-is-data-killing-creativity!./.cache/json/authors-is-data-killing-creativity.json
// module id = 1294
// module chunks = 231608221292675